import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
    }
  },
  props: ['image'],
  computed: {
    ...mapGetters(['audio'])
  },
  methods: {
    ...mapActions(['setAudio']),
    previewFile($event) {
      let input = $event.target;
      if (input.files?.[0].type === 'audio/mpeg' || input.files?.[0].type === 'audio/mp3') {
        // create a new FileReader
        let reader = new FileReader();
        let fileName = input.files[0].name;

        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Read result and set url in setFileUr
          const url = e.target.result;
          let obj = {
            name: fileName,
            url: url,
            blob: input.files?.[0],
          };
          this.setAudio(obj);
          this.getTimeAudio(url);
          console.log(this.audio);
        }
        // Start the reader job - read file as a data url
        reader.readAsDataURL(input.files[0]);
      } else {
        console.error("O arquivo não é do tipo MP3.");
      }
    },
    getTimeAudio(url) {
      // Cria um elemento de áudio
      const audio = new Audio();
      const self = this;

      // Define um manipulador de eventos para o evento 'loadedmetadata'
      audio.addEventListener('loadedmetadata', function () {
        // A propriedade duration contém a duração do áudio em segundos
        self.setAudio({...self.audio, time: audio.duration})
        console.log('Duração do arquivo MP3:', audio.duration, 'segundos');
      });

      // Define um manipulador de eventos para o evento 'error'
      audio.addEventListener('error', function (e) {
        console.error('Erro ao carregar o arquivo MP3:', e);
      });

      // Define o conteúdo do áudio como base64
      audio.src = url;

      // Inicia o processo de carregamento
      audio.load();
    },
    clearInputFile() {
      this.$refs.fileupload.value = null;
      this.setAudio(null);
    }
  },
}
